import { NextRequest } from 'next/server';
import buildShopSubdomainUrl from '../shopSubdomain';
import { CartAttribute, ShopifyVariant } from '@/lib/shopify';
import { SUBSCRIPTION_STATUS } from '@/lib/api/subscriptionManager/types';

export const legacyHost =
  process.env.NEXT_PUBLIC_BACKEND_DOMAIN || 'lovevery.com';

export function getShopifySubflowUrl(req: NextRequest) {
  const path = req.nextUrl.pathname.replace('-v3', '');
  const locale = req.nextUrl.locale;
  const shopifySubFlowUrl = buildShopSubdomainUrl(path, locale);
  return shopifySubFlowUrl;
}

export function getDefaultVariant(
  productTitle: string,
  variants: ShopifyVariant[],
): ShopifyVariant {
  // if product "Organic Cotton Baby Doll", use "Tan Skin Tone" variant by default
  const organicCottonBabyDollTitle = 'Organic Cotton Baby Doll';
  const organicCottonBabyDollDefaultIndex = 1; // "Tan Skin Tone" index

  if (productTitle === organicCottonBabyDollTitle) {
    return variants?.[organicCottonBabyDollDefaultIndex] || variants[0];
  }

  return variants[0];
}

export function getCartLineItemProperty(
  targetAttributeKey: string,
  attributes?: CartAttribute[],
) {
  if (!attributes) {
    return null;
  }

  const keySet = new Set([targetAttributeKey, `_${targetAttributeKey}`]);

  const targetAttribute = attributes?.find((attribute) => {
    return keySet.has(attribute.key);
  });

  return targetAttribute?.value;
}
